import React, { useState } from 'react';
import { Bars3Icon } from '@heroicons/react/20/solid';
import { useLocation } from 'react-router-dom';
import Logo from './Logo';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';
import { MenuItem } from '../types/navigation';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems: MenuItem[] = [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'About Us',
      href: '/about',
    },
    {
      label: 'Events',
      href: '/events',
    },
    {
      label: 'Collaboration',
      href: '/collaboration',
    },
    {
      label: 'Become a Member',
      href: '/membership',
    },
  ];

  const isActiveItem = (item: MenuItem): boolean => {
    if (item.href && currentPath === item.href) return true;

    // Special case: treat /events/past and /events/upcoming as active for Events menu item
    if (
      item.href === '/events' &&
      (currentPath === '/events/past' || currentPath === '/events/upcoming')
    ) {
      return true;
    }

    return false;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="shadow-lg sticky top-0 z-50 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <div className="flex items-center">
            <Logo />
          </div>

          {/* Desktop Navigation */}
          <DesktopNavigation
            menuItems={menuItems}
            isActiveItem={isActiveItem}
          />

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMobileMenu}
              className="p-2 rounded-lg text-secondary-900 hover:opacity-80 transition-colors duration-200 cursor-pointer"
            >
              <Bars3Icon className="h-6 w-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <MobileNavigation
        menuItems={menuItems}
        isMobileMenuOpen={isMobileMenuOpen}
        onCloseMobileMenu={closeMobileMenu}
        isActiveItem={isActiveItem}
      />
    </header>
  );
};

export default Header;
